import AppIcon from '@shelflix/ui-web/components/AppIcon';
import React from 'react';
import wifiWarningSvg from '@/assets/icons-normalized/wifi-warning.svg?raw';
import { DashboardCard } from '../DashboardCard';
import { cn } from '@/utils/utils';

export interface CampaignOverviewItem {
  title: string;
  count: number;
  color: string;
  bgColor: string;
  icon: string;
  /** Optional status filter value to apply when clicking on the card */
  statusFilter?: string;
}

export function CampaignOverview({
  campaignOverviewData,
  className,
}: {
  campaignOverviewData: CampaignOverviewItem[];
  className?: string;
}) {
  return (
    <DashboardCard title="Campanhas" icon={wifiWarningSvg} className={cn('bg-[#191919CC]', className)}>
      <div className="grid-wrap grid h-full grid-cols-2 gap-x-3 gap-y-4">
        {campaignOverviewData.map((item, index) => (
          <div
            key={`campaign-item-${index}`}
            className="grid grid-cols-[auto_1fr] items-center gap-2 rounded-[5px] bg-[#0E0E0E] px-4 py-7"
            style={{ color: item.color }}
          >
            <AppIcon
              source="svg"
              name={item.title.toLowerCase()}
              svgContent={item.icon}
              size={40}
              weight={400}
              colorStyle={{ type: 'solid', color: item.color }}
              style={{ backgroundColor: item.bgColor }}
              className="rounded-[5px] p-2.5"
            />
            <div className="flex flex-col justify-center gap-1 overflow-hidden">
              <h4 className="truncate text-base font-normal">{item.title}</h4>
              <h4 className="truncate text-base font-normal">{item.count}</h4>
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
